import { resolveOsDefaultLandingPath, type DefaultRouteOptions } from "@/utils/routeUtils";
import type { OpenWindowConfig } from "./useWindow";
import { APP_REGISTRY } from "./OsAppRegistry";
import { parseUrlToWindowConfig } from "./urlMapping";
import type { OsWindow } from "./OsContext";

export function openLandingWindowFromPath(
  landingPath: string,
  windows: readonly OsWindow[],
  openWindow: (config: OpenWindowConfig) => void,
  focusWindow: (windowId: string) => void,
): void {
  if (!landingPath || landingPath === "/") return;

  const windowConfig = parseUrlToWindowConfig(landingPath);
  if (!windowConfig) return;

  const appDef = APP_REGISTRY[windowConfig.appId];
  if (!appDef) return;

  const existing = windows.find((w) => w.appId === windowConfig.appId);
  if (existing) {
    focusWindow(existing.id);
    return;
  }

  openWindow({
    appId: windowConfig.appId,
    title: windowConfig.title,
    params: windowConfig.params,
    initialSize: appDef.defaultSize,
  });
}

export function resolveAndOpenDefaultLandingWindow(params: {
  companyId?: string | null;
  initialRoute?: string | null;
  hasPermission: (module: string) => boolean;
  routeOptions?: DefaultRouteOptions;
  windows: readonly OsWindow[];
  openWindow: (config: OpenWindowConfig) => void;
  focusWindow: (windowId: string) => void;
}): string {
  const landingPath = resolveOsDefaultLandingPath(
    params.companyId,
    params.initialRoute ?? undefined,
    params.hasPermission,
    params.routeOptions,
  );
  openLandingWindowFromPath(
    landingPath,
    params.windows,
    params.openWindow,
    params.focusWindow,
  );
  return landingPath;
}
